/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Payment extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Payment;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/payment.js